import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function loadDiagramSuccess(content) {
  return { type: types.LOAD_DIAGRAM_SUCCESS, content };
}

export function updateDiagramSuccess(content) {
  return { type: types.UPDATE_DIAGRAM_SUCCESS, content };
}

export function createDiagramSuccess(content) {
  return { type: types.CREATE_DIAGRAM_SUCCESS, content };
}

export function deleteDiagramSuccess(contentId) {
  return { type: types.DELETE_FROM_CONTENT_LIST_SUCCESS, contentId };
}

export function loadDiagram(diagramId) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/diagram?id=${diagramId}`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(loadDiagramSuccess(res.data));
    }))
    .catch((error) => {
      throw (error);
    });
  };
}

export function saveDiagram(content) {
  return function(dispatch) {
    let method;
    if (content.id) {
      // If we are editing a diagram (an ID will exist)
      method = `PUT`;
    } else {
          // If we are creating a brand new diagram (no ID)
      method = `POST`;
    }
    return fetch(`${getAPIPath}commandapi/diagram`, {
      method,
      body: JSON.stringify(content),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
      .then(handleErrors)
      .then(response => response.json().then((res) => {
        return res.data;
      }))
      .catch((error) => {
        let message;
        if (error.status && error.status === 401) {
          message = `You do not appear to be logged in. Please log in again to proceed`;
        } else {
          message = `There was a problem saving your practice. Please contact us if the problem persists.`;
        }
        dispatch(addNotification({
          message,
          level: `error`,
          autoDismiss: 0,
        }));
        throw (error);
      });
  };
}

export function saveDiagramImage(object) {
  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/snapshot/pitchdiagram`, {
      method: `POST`,
      body: JSON.stringify(object),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .catch((error) => {
      dispatch(addNotification({
        message: `There was a problem saving your diagram. Please contact us if the problem persists.`,
        level: `error`,
        autoDismiss: 0,
      }));
      throw (error);
    });
  };
}

export function deleteDiagram(diagramId, forceDelete) {
  let forceDeleteParams = ``;
  if (forceDelete) {
    forceDeleteParams = `&force_delete=${forceDelete}`;
  }

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/diagram?id=${diagramId}${forceDeleteParams}`, {
      method: `DELETE`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      if (response.status === 409) {
        throw response;
      } else {
        response.json().then(() => {
          dispatch(deleteDiagramSuccess(diagramId));
          dispatch(addNotification({
            message: `Successfully deleted`,
            level: `success`,
            autoDismiss: 3,
            dismissible: `click`,
          }));
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/diagramActions.js